module.exports = new __parcel__URL__("apply_k_faq_expanded_ja.4c5f2d3d.webp").toString();